export default "/e891d4a0bdc60f2a6a9b4e97d7422547d2a79dc5/a92d826d80900dda6092d3b109ffaee1.svg";